module.exports = __webpack_public_path__ + "static/fonts/iconfont.4f0d3b4.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.eot?t=1487055721860
// module id = 68
// module chunks = 2